import { render, staticRenderFns } from "./PessoaFisica.vue?vue&type=template&id=4df59490"
import script from "./PessoaFisica.vue?vue&type=script&lang=js"
export * from "./PessoaFisica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports